module.exports = __webpack_public_path__ + "img/668-a43686.png";